import { render, staticRenderFns } from "./HowtoBackground.vue?vue&type=template&id=3b3d1bbe&scoped=true&"
import script from "./HowtoBackground.vue?vue&type=script&lang=js&"
export * from "./HowtoBackground.vue?vue&type=script&lang=js&"
import style0 from "./HowtoBackground.vue?vue&type=style&index=0&id=3b3d1bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d1bbe",
  null
  
)

export default component.exports